import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import PageForm from 'components/Shared/PageForm/Index'
import { confirm } from 'components/Shared/ConfirmDialog/Index'
import Button from 'components/Shared/Button/Index'


const StyledPageForm = styled(PageForm)`
  margin-top: 24px;
`

const removeReleaseConfirm = (t, onRemoveClick) => {
  confirm({
    title: t('releaseNotesPage.removeReleaseTitle'),
    message: t('releaseNotesPage.removeReleaseMessage'),
    t,
  }).then(
    () => { onRemoveClick() },
    () => {}
  )
}

const AddEditReleaseForm = ({ onSubmit, onCloseClick, onRemoveClick, editRelease }) => {
  const { t } = useTranslation()
  const isEdit = !!editRelease
  const submitTitle = isEdit ? t('releaseNotesPage.formUpdateRelease') : t('common.save')

  const AdditionalButton = !isEdit
    ? undefined
    : () => {
        return (
          <Button
            alert
            large
            onClick={() => removeReleaseConfirm(t, onRemoveClick)}
          >
            {t('releaseNotesPage.formRemoveRelease')}
          </Button>
        )
      }

  const formFieldParams = [
    {
      name: 'version',
      label: t('releaseNotesPage.formVersion'),
      type: 'text',
      placeholder: t('releaseNotesPage.formVersionPlaceholder'),
      required: true,
    },
    {
      name: 'date',
      label: t('releaseNotesPage.formDate'),
      type: 'datetime',
      placeholder: t('releaseNotesPage.formDatePlaceholder'),
      required: true,
      userTimeZone: 'UTC',
      isDateOnly: true,
    },
    {
      name: 'published',
      label: t('releaseNotesPage.formPublished'),
      type: 'switch',
    },
    {
      name: 'description',
      label: t('releaseNotesPage.formDescription'),
      type: 'textarea',
      placeholder: t('releaseNotesPage.formDescriptionPlaceholder'),
      tooltip: t('releaseNotesPage.formDescriptionTooltip'),
      required: true,
      minRowsTextArea: 20,
    },
  ]

  return (
    <StyledPageForm
      onSubmit={onSubmit}
      onCancel={onCloseClick}
      fieldParams={formFieldParams}
      actionButtonTitle={submitTitle}
      additionalButton={!!AdditionalButton && <AdditionalButton />}
      confirmOnSubmit
      initialValues={{
        version: editRelease?.version,
        date: editRelease?.date,
        published: editRelease?.published,
        description: editRelease?.description,
      }}
    />
  )
}

AddEditReleaseForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func,
  editRelease: PropTypes.object,
}

export default AddEditReleaseForm
